export const ConcatAndCapitalizeFullName = (data: any) => {
    return `${data?.firstName}${data?.middleInitial ? ` ${data?.middleInitial}` : ''}${data?.lastName ? ` ${data?.lastName}` : ''}`.toUpperCase();
  };

  export const ConcatAddress = (data: any) => {
    return `${data?.line1 ? ` ${data?.line1}` : ''}${data?.line2 ? ` ${data?.line2}` : ''}`;
  };